import {connect} from "react-redux"
import State from "../../../models/State"

export const mapStateToProps = (state: State) => {
    const templating = state.template
    return {
        templating,
    }
}

export default connect(mapStateToProps)
